/**
 * Created by fers on 19/03/2017.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import {injectIntl, IntlShape} from 'react-intl';
import Relay from 'react-relay';

import {getMessageArgsForDataSource} from '../screen-settings/DataSourceList.react';

class DataSourceDecorationEdit extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        dataSource: PropTypes.object.isRequired,
        goBack: PropTypes.func,
        intl: PropTypes.object,
    };

    render() {
        let dataSource = this.props.dataSource;

        let messageArgs = getMessageArgsForDataSource(dataSource, dataSource.relativeTo);

        let name = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSource.typeId + '.name',
        }, messageArgs);

        let description = this.props.intl.formatMessage({
            id: 'dataSource.' + dataSource.typeId + '.description',
        }, messageArgs);

        return (
            <div className="dataSource-item-detail">
                <div className="dataSource-head flex">
                    <div className={"dataSource-item-close"}>
                        <div className="btn btn-inline" onClick={this.props.goBack}><span className="fa fa-chevron-left"/></div>
                    </div>
                    <div className="dataSource-idx-box">
                        <span className="dataSource-idx" title={description}>#{dataSource.idx}</span>
                    </div>
                    <div className="dataSource-title-icon">
                        {dataSource.channelDefs && dataSource.channelDefs.length > 0 ? dataSource.channelDefs.map((channelDef, idx) => channelDef.icon ? <ChannelIcon channelDef={channelDef} key={idx} size={32} /> : null) : <ChannelIcon channelDef={{icon: 'dativery'}} size={32} />}
                    </div>
                    <div className={"dataSource-item-title" + (description ? '' : ' one-line-title')}>
                        <h3>{name}</h3>

                        {description ? <small>{description}</small> : null}
                    </div>
                </div>

                <div className="dataSource-item-dataSources">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Relay.createContainer(injectIntl(DataSourceDecorationEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    name,
                    description,
                    idx,
                    relativeTo {
                        id,
                        name
                    },
                    channelDefs {
                        id,
                        icon,
                        name,
                    },
                    entityDefs {
                        id,
                        name,
                    }
                }`;
        }
    }
});
